import { BaseServiceDefinition } from './BaseService';
import { Position } from '../models/position';

class MemberContactsServiceDefinition extends BaseServiceDefinition {
    getMembersForArea(pos: Position) {
        return this.get('/api/v1/memberContacts/area?longitude=' + pos.longitude + '&latitude=' + pos.latitude);
    }

    getMembersForVo(vo: string) {
        return this.get('/api/v1/memberContacts/vo?number=' + vo);
    }

    getVoOffices(){
        return this.get('/api/v1/memberContacts/office');
    }
}

export const MemberContactsService: MemberContactsServiceDefinition = new MemberContactsServiceDefinition();